















export default

	props: stats: Array

